import '../types/global.d.ts';

import photo_of_toby from '../img/Photo of Me.jpg';
import cv from '../cv.pdf';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import YouTubeIcon from '@mui/icons-material/YouTube';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

function AboutMe() {
    return (
    <div className="About_Me">
        <p>
            <img src={photo_of_toby} alt="Photo of Toby" width="300" height="310" style={{ paddingRight: 20 }}/>
            <h3>About me</h3>
            I studied a Bachelor of Science, majoring in Computer Science, at the University of Canterbury.
            <br/>
            <br/>
            I am currently available for any type of work to initiate my career in the IT industry.
            I am primarily applying for the role of a software engineer but would like to gain work experience in all fields related to IT.
            My long term goal is to work in cyber security to help prevent websites and people against cyber attacks.
            In my spare time I'd like to keep working on game development to make unique and popular games.
            <br/>
            <br/>
            The ideal job for me would help me to learn as much as I can about what it's like to work within the IT industry and how to work on a vast range of commonly faced tasks and problems encountered.
            <br/>
            <br/>
            Below are links to download my CV, find the source code for my projects on my GitHub including this website, my LinkedIn and my Youtube channel which feature the games that I made.
        <br/>
        <Tooltip title="Download my CV">
            <IconButton>
            <a href={cv} download="Toby Morgan - CV (Public)">
            <PictureAsPdfIcon fontSize="large"/>
            </a>
            </IconButton>
        </Tooltip>
        <Tooltip title="GitHub">
            <IconButton>
            <a href="https://github.com/CrazyMorgan0" target="_blank" rel="noreferrer">
            <GitHubIcon fontSize="large"/>
            </a>
            </IconButton>
        </Tooltip>
        <Tooltip title="LinkedIn">
            <IconButton>
            <a href="https://www.linkedin.com/in/crazymorgan0/" target="_blank" rel="noreferrer">
            <LinkedInIcon fontSize="large"/>
            </a>
            </IconButton>
        </Tooltip>
        <Tooltip title="YouTube">
            <IconButton>
            <a href="https://www.youtube.com/@tobymorgan6263/featured" target="_blank" rel="noreferrer">
            <YouTubeIcon fontSize="large"/>
            </a>
            </IconButton>
        </Tooltip>
        </p>
    </div>
    );
}

export default AboutMe;